(function($) {

    $.fn.gCalReader = function(options) {
        var $div = $(this);

        var defaults = $.extend({
                calendarId: 'editionsdupantheon@gmail.com',
                apiKey: 'AIzaSyCb11isaU6GAsiq0uPICyMTI3xP2ZMBCxU',
                errorMsg: 'Pas d\'évènement',
                maxEvents: 50,
                futureEventsOnly: true,
                sortDescending: true,
                eventId: null
            },
            options);

        var s = '';
        var feedUrl = 'https://www.googleapis.com/calendar/v3/calendars/' +
            encodeURIComponent(defaults.calendarId.trim()) +'/events?key=' + defaults.apiKey +
            '&orderBy=startTime&singleEvents=true';
        if(defaults.futureEventsOnly) {
            feedUrl+='&timeMin='+ new Date().toISOString();
        }

        $.ajax({
            url: feedUrl,
            dataType: 'json',
            success: function(data) {
                if(defaults.sortDescending){
                    data.items = data.items.reverse();
                }
                data.items = data.items.slice(0, defaults.maxEvents);

                $.each(data.items, function(i, item) {
                    var startdate = item.start.dateTime || item.start.date ||'';
                    var starttime = moment(item.start.dateTime).format("hh:mm");
                    var enddate = item.end.dateTime || item.end.date ||'';
                    var endtime = moment(item.end.dateTime).format("hh:mm");
                    var summary = item.summary || '';
                    var description = item.description;
                    var location = item.location;

                    if((defaults.eventId == null) ||(summary.split("_")[0] == defaults.eventId)){
                        s ='<a id="eventModal' + i + '">';
                        s +='<span class="Event-date">' + moment(startdate).format("D MMMM") + '</span>';
                        //if(enddate != startdate) {
                        //    s +=' - ' + moment(enddate).format("D MMMM");
                        //}
                        s +='<span class="Event-title">' + summary.split("_").pop() + '</span>';
                        s +='</a>';

                        var a = '';
                        a ='<div class="Event-date"><strong>' + moment(startdate).format("D MMMM YYYY") + '</strong></div><br>';
                        //if(starttime != '' && endtime != '') {
                        //    a +='<div class="Event-time">'+ starttime + ' - ' + endtime + '</div><br>';
                        //}
                        if(description) {
                            a +='<div class="Event-description">'+ description +'</div><br>';
                        }
                        if(location) {
                            a +='<div class="Event-location"><em>' + location + '</em></div>';
                        }

                        $($div).append('<li>' + s + '</li>');

                        $('#eventModal' + i).on('click', function(){
                            swal({
                                title: summary.split("_").pop(),
                                text: a,
                                html: true,
                                showConfirmButton: true
                            });
                        });
                    }
                });
            },
            error: function(error) {
                $($div).append('<p>' + defaults.errorMsg + ' | ' + error + '</p>');
            }
        });
    };

}(jQuery));
